var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step",class:{
    'step--active': _vm.active,
    'step--done': _vm.done
  }},[_c('span',{staticClass:"step__dot"},[(_vm.done)?_c('check-circle-icon',{staticClass:"step__icon",attrs:{"size":"0.75x"}}):_c('span',{staticClass:"step__dot__inner"})],1),_c('span',{staticClass:"step__text"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }